import { render, staticRenderFns } from "./RawMaterialList.vue?vue&type=template&id=0b6bc8f6&scoped=true"
import script from "./RawMaterialList.vue?vue&type=script&lang=js"
export * from "./RawMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6bc8f6",
  null
  
)

export default component.exports